<template>
  <a-modal
    title="上传题库"
    :visible="visible"
    :confirm-loading="confirmLoading"
    @ok="handleOk"
    width=""
    centered
    :keyboard="false"
    :maskClosable="false"
    @cancel="handleCancel"
    okText="完成"
    :getContainer="getContainer"
  >
    <div class="content">
      <div class="content1">
        <FormItem label="题库名称">
          <a-input
            size="large"
            v-model="dataForm.name"
            placeholder="请输入题库名称"
          />
        </FormItem>
        <br />
        <FormItem label="上传题库">
          <SelectFile
            ref="SelectFile"
            :selectStyle="{ height: '40px' }"
            @change="specifiName"
            label="请选择题库"
            accept=".csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          />
        </FormItem>
        <div class="downloadFile" @click="downloadFile">
          <a-icon type="download" style="color: #0073ff" />
          下载模板
        </div>
      </div>
      <div class="content2" v-if="files.length > 0">
        <div>待上传列表：</div>
        <!-- <div>(已存在待保存列表的文件会帮您自动过滤)</div> -->
        <a-list item-layout="horizontal" :data-source="files">
          <a-list-item slot="renderItem" slot-scope="item, index">
            <a-list-item-meta>
              <a-tooltip slot="title">
                <template slot="title"> {{ item.question }} </template>
                <div class="title" style="color: #000">
                  {{ index + 1 }}、{{ item.question }}
                </div>
              </a-tooltip>

              <div slot="description" class="description">
                <div class="left">
                  <div>
                    {{
                      "类型：" +
                      (item.type == 1
                        ? "单选题"
                        : item.type == 2
                        ? "判断题"
                        : item.type == 3
                        ? "多选题"
                        : "")
                    }}
                  </div>
                  <div>{{ "答案：" + item.answer }}</div>
                </div>
                <div class="del">
                  <a @click="delFile(index)">
                    <a-icon
                      type="close-circle"
                      style="color: red; font-size: 18px"
                    />
                  </a>
                </div>
              </div>
            </a-list-item-meta>
          </a-list-item>
        </a-list>
      </div>
    </div>
  </a-modal>
</template>
  
  <script>
import { handleFileUpload, saveExcel } from "@/utils/os";
import { companyFileBatch } from "@/utils/exportFile";
import { isDateOrDateTime, excelTimeFormat } from "@/utils/util";
import SelectFile from "@/components/SelectFile/index";
import { addTopics } from "@/request/classes";
import FormItem from "@/components/FormItem/index";
import { getExtension } from "mime";
import { isVideoFileType } from "@/utils/util";
import fs from "fs";
import path from "path";
import { saveAs } from "file-saver";
export default {
  components: { SelectFile, FormItem },
  data() {
    return {
      visible: false,
      confirmLoading: false,
      dataForm: {
        name: "", //题库名称
      },
      files: [],
    };
  },
  methods: {
    getExtension,
    init() {
      this.visible = true;
    },
    formatFileSize(size) {
      if (size === 0) {
        return "0 B";
      }
      const units = ["B", "KB", "MB", "GB", "TB"];
      const base = 1024;
      const digitGroups = Math.floor(Math.log10(size) / Math.log10(base));
      const formattedSize = (size / Math.pow(base, digitGroups)).toFixed(2);
      return `${formattedSize} ${units[digitGroups]}`;
    },
    //删除上传的文件
    delFile(index) {
      this.files.splice(index, 1);
    },
    //选择的文件地址回调

    specifiName($event) {
      console.log("选择的文件地址回调");
      this.p = document.getElementById("open").files[0].path;
      const is_ = this.isTableFile(this.p);
      if (!is_) {
        $event.srcElement.value = ""; //及时清空
        return this.$message.warning("请选择 .xlsx、.xls 或 .csv 结尾的文件");
      }
      handleFileUpload($event).then((jsonData) => {
        jsonData.splice(0, 2);
        let ok = [];
        for (let i = 0; i < jsonData.length; i++) {
          let obj = jsonData[i];
          console.log(obj);
          let type = obj[0]; //题目类型1单选2判断3多选
          if (!type) continue;
          const question = obj[1]; //题目问题
          if (!question) continue;
          const q1 = obj[2] || ""; //选项A
          const q2 = obj[3] || ""; //选项B
          const q3 = obj[4] || ""; //选项C
          const q4 = obj[5] || ""; //选项D
          const answer = obj[6] || ""; //答案
          if (!answer) continue;
          if (type == 1 && answer.length > 1) type = 3; //模板中1是选择题2是判断题，如果是1并且答案长度大于1，则视为多选
          const belong = "2";
          ok.push({
            type: type,
            question: question,
            answer: answer,
            q1: q1,
            q2: q2,
            q3: q3,
            q4: q4,
            belong: belong,
          });
        }
        console.log(JSON.parse(JSON.stringify(ok)));
        this.files = ok;
        this.$message.success("读取成功");
      });
      $event.srcElement.value = ""; //及时清空
    },
    isTableFile(url) {
      // 在正则表达式中使用 $ 表示字符串的结尾
      var regex = /\.xlsx$|\.xls$|\.csv$/i; // 匹配 .xlsx、.xls 或 .csv 结尾的文件
      return regex.test(url);
    },
    getDu(file) {
      return new Promise((resolve) => {
        var reader = new FileReader();
        reader.onload = () => {
          var video = document.createElement("video");
          video.src = reader.result;
          const eventFn = () => {
            const duration = Math.floor(video.duration * 100) / 100;
            video.removeEventListener("loadedmetadata", eventFn);
            resolve(duration);
          };
          video.addEventListener("loadedmetadata", eventFn);
        };
        reader.readAsDataURL(file);
      });
    },
    isTableFile(url) {
      // 在正则表达式中使用 $ 表示字符串的结尾
      var regex = /\.xlsx$|\.xls$|\.csv$/i; // 匹配 .xlsx、.xls 或 .csv 结尾的文件
      return regex.test(url);
    },
    handleOk() {
      if (!this.dataForm.name) return this.$message.warning("请输入题库名称");
      if (this.files.length == 0)
        return this.$message.warning("请选择题库文件");
      this.confirmLoading = true;
      const data = {
        name: this.dataForm.name,
        arr: this.files,
      };
      addTopics(data)
        .then(() => {
          this.$message.success("上传题库成功");
          this.handleCancel();
        })
        .finally(() => {
          this.confirmLoading = false;
          this.$emit("ok");
        });
    },
    handleCancel() {
      this.files = [];
      this.dataForm.name = "";
      this.confirmLoading = false;
      this.visible = false;
    },
    //下载模板
    downloadFile() {
      const url = path.resolve("static/题库模板.xlsx");
      fs.readFile(url, (err, data) => {
        if (err) {
          this.$error({
            title: "文件不存在，请检查",
            content: url,
            getContainer: ()=> document.getElementById("bodyContnet"),
          });
        } else {
          const excelData = new Blob([data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
          });
          saveAs(excelData, "题库模板.xlsx");
          this.$message.success("保存成功")
        }
      });
    },
    getContainer() {
      return document.getElementById("bodyContnet");
    },
  },
};
</script>
  
  <style scoped>
.downloadFile {
  font-size: 12px;
  color: #011733;
  margin-top: 15px;
  cursor: pointer;
  display: inline-block;
  padding-left: 94px;
}

.content {
  display: flex;
}
.content1 {
  width: 350px;
}
.content2 {
  width: 300px;
  margin-left: 20px;
  max-height: 80vh;
  overflow-y: auto;
}
.description {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 280px;
  /* border: 1px solid red; */
}
.left {
  width: 80%;
}
.del {
}
.downloadFile {
  font-size: 12px;
  color: #011733;
  margin-top: 15px;
  cursor: pointer;
  display: inline-block;
}
</style>